import kaplay from "kaplay";
import "kaplay/global"; // uncomment if you want to use without the k. prefix
/* const k = kaplay(); */

kaplay({
  width: 500,
  height: 400,
  background: "#a5b8c7",
  canvas: document.getElementById("game-canvas"),
  letterbox: false,
  debugKey: "w",
});

setGravity(1600);
const FLOOR_HEIGHT = 58;
const DEF_SPEED = 480;
const ADD_SPEED = 30;

/*
////////////////////////
//// SPRITE
///////////////////////
*/


loadRoot("./"); // A good idea for Itch.io publishing later

loadSprite("player", "sprites/player-run.png", {
  sliceX: 0,
  sliceY: 4,
  anims: {
    run: { from: 0, to: 3, loop: true },
    jump: { from: 0, to: 0, loop: false },
  },
});

loadSprite("pc", "sprites/server.png", {
  sliceX: 0,
  sliceY: 12,
  anims: {
    danger: { from: 0, to: 11, loop: true },
  },
});

loadSprite("server", "sprites/server2.png", {
  sliceX: 0,
  sliceY: 8,
  anims: {
    danger: { from: 0, to: 7, loop: true },
  },
});
loadSprite("floppy", "sprites/floppy.png", {
  sliceX: 0,
  sliceY: 4,
  anims: {
    danger: { from: 0, to: 3, loop: true },
  },
});

/*
////////////////////////
//// SCENE
///////////////////////
*/
scene("intro", () => {
  add([text(`Let's Go`), pos(width() / 2, 180), anchor("center")]);
  add([text(`Click to start` , {size:'24'}), pos(width() / 2, 240), anchor("center")]);
  onKeyPress("s", () => {
    go("game");
  });
  onClick(() => {
    go("game");
  });
});

scene("game", () => {
  initGame();
});

scene("gameover", (score) => {
  add([text(`Game Over`), pos(width() / 2, 140), anchor("center")]);
   add([
        text(score,{size:'32'}),
        pos(width() / 2, 200),
        anchor("center"),
    ]);
    add([text(`Click to restart`,{size:'24'}), pos(width() / 2, 300), anchor("center")]);
  onKeyPress("s", () => {
    go("game");
  });
  onClick(() => {
    go("game");
  });
});
/*
////////////////////////
//// SCENE
///////////////////////
*/

const initGame = () => {
  //score
  let score = 0;
  const scoreLabel = add([text(score), pos(24, 24)]);
  onUpdate(() => {
    score++;
    scoreLabel.text = score;
  });
  //palyer
  const player = add([
    pos(30, 220),
    scale(3),
    sprite("player"),
    area(),
    body(),
  ]);

  //platform
  add([
    rect(width(), FLOOR_HEIGHT),
    pos(0, height() - FLOOR_HEIGHT),
    outline(4),
    area(),
    body({ isStatic: true }),
    color(61, 83, 107),
  ]);
  //collision
  player.onCollide("enemy", () => {
    addKaboom(player.pos);
    shake();
    go("gameover", score);
  });

  //outcanvas
  window.addEventListener("pointerdown", () => {
    if (player.isGrounded()) {
      player.jump();
      player.play("jump");
    }
});

  onClick(() => {
    if (player.isGrounded()) {
      player.jump();
      player.play("jump");
    }
  });

  //onground
  player.onGround(() => {
    player.play("run");
  });

  //aumenta speed ogni 5 secondi
  let enemySpeed = DEF_SPEED;
  loop(5, () => {
    enemySpeed += ADD_SPEED;
  });

  spawnEnemy();
  function spawnEnemy() {
    const enemy = ["pc", "server", "server", "floppy"];
    const randomSprite = choose(enemy);

    const enemyes = add([
      sprite(randomSprite),
      scale(randomSprite == "floppy" ? 1.2 : 3),
      area(),
      pos(width(), height() - (randomSprite == "floppy" ? 180 : FLOOR_HEIGHT)),
      anchor("botleft"),
      move(LEFT, enemySpeed), //480
      offscreen({ destroy: true }),
      "enemy",
    ]);
    enemyes.play("danger");

    //calcolo velocità nemici
    // Più veloci sono, meno aspettiamo.
    // Sottraiamo un valore che cresce con la velocità
    let min = 1.2 - (enemySpeed - DEF_SPEED) / 1000;
    let max = 1.9 - (enemySpeed - DEF_SPEED) / 1000;

    // Applichiamo i limiti per non scendere troppo
    if (min < 0.7) min = 0.7;
    if (max < 1.1) max = 1.1;

    wait(rand(min, max), () => {
      spawnEnemy();
    });
  }
};
go("intro");
